import React from "react";

const PrintHeader = ({ companyName, jobAddress }) => {
  return (
    <thead className="print-header">
      <tr>
        <td>
          <div className="print-header-content">
            <span className="print-header-left">{companyName}</span>
            <span className="print-header-right">{jobAddress}</span>
          </div>
          <hr className="print-header-divider" />
        </td>
      </tr>
    </thead>
  );
};

export default PrintHeader;
